// // import React from 'react';
// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import Layout from "./Layout";
// import HomeIcon from "../assets/icons/home_icon";
// import Logo from "../images/bentex-logo.png";
// import axios from "axios";
// import config from "../config";
// import ClipLoader from "react-spinners/ClipLoader";
// import { jsPDF } from "jspdf"; // Import jsPDF
// import html2pdf from "html2pdf.js";  // Import html2pdf.js
// import { toast } from "react-toastify";

// const Invoice = ({ customerDetails, invoiceDetails, items, handlePDF }) => {
//   const { id } = useParams();
//   const location = useLocation();
//   const [amountPaid, setAmountPaid] = useState(0);
//   const [uploadedImages, setUploadedImages] = useState([]);
//   const [deposits, setDeposits] = useState([
//     { percent: 0, amount: 0, mode: "" },
//     { percent: 0, amount: 0, mode: "" },
//     { percent: 0, amount: 0, mode: "" },
//   ]);


//   const queryParams = new URLSearchParams(location.search);
//   // const totalPrice = queryParams.get("total_price");

//   const [quoteNo, setQuoteNo] = useState("");
//   const [product, setProduct] = useState("");
//   const [isEmailLoading, setIsEmailLoading] = useState(false);

//   const [netPrice, setNetPrice] = useState("");
//   const [totalPrice, setTotalPrice] = useState("");
//   const [deliveryDate, setDeliveryDate] = useState("");
//   const [weddingDate, setWeddingDate] = useState("");
//   const [comments, setComments] = useState("");
//   const [customer, setCustomer] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [products, setProducts] = useState([]);
//   const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split('T')[0]);
//   const [status, setStatus] = useState("Pending");
//   const [invoiceNo, setInvoiceNo] = useState("");
//   // const [deposit, setDeposit] = useState([]);
//   const [modeOfPayment, setModeOfPayment] = useState("");
//   const [amountDue, setAmountDue] = useState(0);

//   const [totalAmount, setTotalAmount] = useState("");
//   useEffect(() => {
//     setAmountDue(totalPrice - amountPaid);
//   }, [totalPrice, amountPaid]); // ✅ dependency array


//   // console.log(totalPrice)
//   //   useEffect(() => {
//   //   const total = products.reduce((acc, product) => {
//   //     const price = parseFloat(product.price) || 0;
//   //     const quantity = parseInt(product.quantity) || 0;
//   //     return acc + price * quantity;
//   //   }, 0);

//   //   setTotalAmount(total.toFixed(2)); 
//   // }, [products]);


//   const navigate = useNavigate();
//   useEffect(() => {
//     const fetchQuoteDetails = async () => {
//       try {
//         const response = await axios.get(`${config.BASE_URL}/api/v1/quoteDetail/${id}`);
//         console.log(response,"response")
//         const data = response.data.quoteDtail;
//         const productData = response.data.productDetail
//         console.log(data, "data")
//         setQuoteNo(data?.quoteNo || "");
//         // setNetPrice(data?.totalPrice || "");
//         setTotalPrice(data.totalPrice || "");
//         setAmountDue(data.totalPrice || "")
//         setDeliveryDate(data?.deliveryDate || "");
//         setWeddingDate(data?.weddingDate || "");
//         setComments(data?.comments || "");
//         setProducts(productData || []);
//         setCustomer(data?.customer_id)

//       } catch (error) {
//         console.error("Error fetching quote details:", error);
//       }
//     };

//     if (id) {
//       fetchQuoteDetails();
//     }
//   }, [id]);
//   // console.log(totalAmount)



//   const calculateAmountDue = (selectedDeposits) => {
//     let amountPaid = 0;

//     if (selectedDeposits.includes("25% deposit paid")) {
//       amountPaid += totalPrice * 0.25;
//       // console.log(amountPaid)
//       setAmountPaid(amountPaid);
//     }

//     if (selectedDeposits.includes("25% deposit due")) {
//       amountPaid += totalPrice * 0.25;
//       setAmountPaid(amountPaid);
//     }

//     if (selectedDeposits.includes("50% deposit paid")) {
//       amountPaid += totalPrice * 0.5;
//       setAmountPaid(amountPaid);
//     }

//     const due = totalPrice - amountPaid;
//     setAmountDue(due);
//   };

//   // console.log(amountPaid)


//   const generateRandomOrderNo = () => {
//     const randomNumber = Math.floor(Math.random() * 100000) + 1000;
//     return `AR${randomNumber}`;
//   };

//   const checkOrderNoExistence = async (generatedOrderNo) => {
//     try {
//       const response = await axios.get(`${config.BASE_URL}/api/v1/checkOrderNo`, {
//         params: { orderNo: generatedOrderNo }
//       });
//       return response.data.exists;
//     } catch (error) {
//       console.error("Error checking quote number existence:", error);
//       return false;
//     }
//   };

//   const handleDepositChange = (index, field, value) => {
//     const updated = [...deposits];
//     let numericValue = parseFloat(value) || 0;

//     if (field === "percent") {
//       const amount = ((totalPrice || 0) * numericValue) / 100;
//       updated[index] = { ...updated[index], percent: numericValue, amount };
//     } else if (field === "amount") {
//       const percent = (numericValue / (totalPrice || 1)) * 100;
//       updated[index] = { ...updated[index], amount: numericValue, percent };
//     } else if (field === "mode") {
//       updated[index] = { ...updated[index], mode: value };
//     }

//     setDeposits(updated);

//     // Update totals
//     const totalPaid = updated.reduce((acc, d) => acc + (parseFloat(d.amount) || 0), 0);
//     setAmountPaid(totalPaid);
//     setAmountDue((totalPrice || 0) - totalPaid);
//   };


//   const generateUniqueOrderNo = async () => {
//     let isUnique = false;
//     let newOrderNo = "";

//     while (!isUnique) {
//       newOrderNo = generateRandomOrderNo();
//       isUnique = !(await checkOrderNoExistence(newOrderNo));
//     }

//     setInvoiceNo(newOrderNo);
//   };

//   useEffect(() => {
//     generateUniqueOrderNo();
//   }, []);


//   const handleGeneratePDF = () => {
//     const element = document.getElementById("invoice");

//     const customerName = customer?.customer_name
//       ? customer.customer_name.replace(/\s+/g, "_")
//       : "Customer";

//     const today = new Date();
//     const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
//       today.getMonth() + 1
//     ).padStart(2, "0")}-${today.getFullYear()}`;

//     const fileName = `Invoice_${customerName}_${formattedDate}.pdf`;
//     const options = {
//       margin: 0,
//       filename: fileName,
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: {
//         scale: 2,
//         ignoreElements: (el) => el.classList.contains("no-pdf"),

//       },
//       jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }

//     };
//     html2pdf(element, options);
//   };


//   const handleDeleteItem = (index) => {
//     const updatedProducts = products.filter((_, i) => i !== index);
//     setProducts(updatedProducts);
//   };


//   const handleAddItem = () => {
//     const newItem = {
//       style: '',
//       fabric: '',
//       lining: '',
//       quantity: '',
//       price: '',
//     };
//     setProducts([...products, newItem]);
//   };



//   const handleEmail = async () => {
//     setIsEmailLoading(true);
//     const customerName = customer?.customer_name
//       ? customer.customer_name.replace(/\s+/g, "_")
//       : "Customer";

//     const today = new Date();
//     const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
//       today.getMonth() + 1
//     ).padStart(2, "0")}-${today.getFullYear()}`;

//     const fileName = `Invoice_${customerName}_${formattedDate}.pdf`;
//     try {
//       const element = document.getElementById("invoice");
//       const options = {
//         margin: 0,
//         filename: fileName,
//         image: { type: "jpeg", quality: 0.98 },
//         html2canvas: {
//           scale: 2,
//           ignoreElements: (el) => el.classList.contains("no-pdf"),

//         },
//         jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
//       };

//       const pdfBlob = await html2pdf().from(element).set(options).outputPdf("blob");

//       const formData = new FormData();
//       formData.append("name", customer.customer_name);
//       formData.append("email", customer.email);
//       formData.append("subject", invoiceNo);
//       formData.append("title", fileName);
//       formData.append("pdf", pdfBlob, "invoice.pdf");
//       formData.append("type", "invoice")
//       uploadedImages.forEach((file) => {
//         formData.append("invoiceImages", file); // repeat same field name
//       });


//       const response = await axios.post(`${config.BASE_URL}/api/v1/sendEmail`, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (response.status === 200) {
//         toast.success("Email sent successfully!");
//       } else {
//         toast.error("Failed to send email. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error sending email:", error);
//       toast.error("Error sending email. Please check the console for more details.");
//     } finally {
//       setIsEmailLoading(false); // End button loader
//     }
//   };

//   let customerId = customer?._id;
//   // console.log(customerId)
//   const handleSave = async () => {
//     try {
//       // const invoiceData = {
//       //    invoiceId: id,
//       //   invoiceDate,
//       //   invoiceNo,
//       //   totalPrice,
//       //   amountPaid,
//       //   amountDue,
//       //   id,
//       //   customerId
//       // };


//       const formData = new FormData();

//       // Append all invoice fields
//       // formData.append("invoiceId", id);
//       formData.append("invoiceDate", invoiceDate);
//       formData.append("invoiceNo", invoiceNo);
//       // formData.append("totalAmount", totalAmount);
//       formData.append("amountPaid", amountPaid);
//       formData.append("amountDue", amountDue);
//       formData.append("comments", comments);
//       formData.append("deposit", JSON.stringify(deposits));
//       formData.append("modeOfPayment", modeOfPayment);
//       formData.append("customerId", customerId);
//       formData.append("totalAmount", totalPrice);

//       formData.append("products", JSON.stringify(products));


//       uploadedImages.forEach((image, i) => {
//         formData.append("images", image);
//       });
//       // console.log(totalPrice);

//       const response = await axios.post(`${config.BASE_URL}/api/v1/addInvoice`, formData);
//       if (response.status === 201) {
//         const createdInvoiceId = response?.data?.invoice?._id;
//         toast.success("Invoice saved successfully!");
//         navigate(`/edit-invoice/${createdInvoiceId}`);
//       } else {
//         toast.error("Failed to save the invoice.");
//       }
//     } catch (error) {
//       console.error("Error saving invoice:", error);
//       toast.error("An error occurred while saving the invoice.");
//     }
//   };

// const handleRemoveImage = (indexToRemove) => {
//   setUploadedImages((prevImages) =>
//     prevImages.filter((_, index) => index !== indexToRemove)
//   );
// };

//   return (

//     <Layout>
//       <header className="header">
//         <h1>Edit Invoice</h1>
//         <p><Link to="/" className="home-link">  <HomeIcon /> </Link> / Customers / Edit Invoice</p>
//       </header>

//       <div className="invoice_outer">

//         <div className="invoce_outer_btns">

//           <button
//             onClick={() => handleEmail(customer)}
//             type="button"
//             className="btn"
//             disabled={isEmailLoading}
//           >
//             {isEmailLoading ? (
//               <>
//                 <ClipLoader color="#fff" size={18} /> Sending...
//               </>
//             ) : (
//               "Email"
//             )}
//           </button>


//           <button onClick={handleGeneratePDF} className="btn">PDF</button>
//           <button onClick={handleSave} className="btn">Save</button>
//         </div>

//         <div className="invoice_card" id="invoice">
//           <div className="invoice_card_header">
//             <div className="logo">
//               <img src={Logo} alt="" />
//             </div>
//             <p>CBD Showroom: Suite 513, Level 5, 250 Pitt Street, Sydney 2000</p>
//             <p>Western Sydney: 6, Ambleside Drive, Castle Hill, NSW 2154</p>
//             <p>Ph: 02 9863 6911, Mobile: 0414 984 976</p>
//             <p>ABN: 14146359560</p>
//           </div>
//           <h4 className="tax_invoice_title">Tax Invoice</h4>
//           <div className="invoice_custom_details">
//             <div className="customer_details">
//               <p className="customer_name">{customer?.customer_name}</p>
//               <p className="location">{customer?.address}</p>
//               <p className="email">{customer?.email}</p>
//               <p className="phone_number">{customer?.mobile}</p>
//             </div>
//             <div className="invoice_details_table">
//               <table class="meta">
//                 <tr>
//                   <th><span>Invoice #</span></th>
//                   <td><span>AR8281</span></td>
//                 </tr>
//                 <tr>
//                   <th><span>Date</span></th>
//                   <td><input type="date"
//                     value={invoiceDate}
//                     onChange={(e) => setInvoiceDate(e.target.value)}
//                   /></td>
//                 </tr>
//                 <tr>
//                   <th><span>Amount Due ($)</span></th>
//                   <td><input type="number" value={amountDue} readonly="" formcontrolname="amountDue" class="" /></td>
//                 </tr>
//               </table>
//             </div>
//           </div>

//           <div className="invoice_specification_details">
//             <table className="details">
//               <thead>
//                 <tr>
//                   <th>Item</th>
//                   <th>Fabric / Lining</th>
//                   <th>Quantity</th>
//                   <th>Price ($)</th>
//                   <th>Amount ($)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {products.map((product, index) => (
//                   <tr key={index}>
//                     <td className="with_cut_td">
//                       {index === products.length - 1 ? (
//                         <a className="cut" onClick={handleAddItem}>
//                           +
//                         </a>
//                       ) : (
//                         <a
//                           className="cut"
//                           onClick={() => handleDeleteItem(index)}
//                         >
//                           x
//                         </a>
//                       )}
//                       <select
//                         contentEditable
//                         id="description"
//                         value={product.description}
//                         onChange={(e) => {
//                           const updatedProducts = [...products];
//                           updatedProducts[index].style = e.target.value;
//                           setProducts(updatedProducts);
//                         }}
//                         formcontrolname="description"
//                         className="ng-pristine ng-valid ng-touched"
//                       >
//                         <option value=""> </option>
//                         <option value="Suit">Suit</option>
//                         <option value="Jacket">Jacket</option>
//                         <option value="Shirt">Shirt</option>
//                         <option value="Pant">Pant</option>
//                         <option value="Tuxedo">Tuxedo</option>
//                         <option value="Vest">Vest</option>
//                         <option value="Overcoat">Overcoat</option>
//                         <option value="Accessories">Accessories</option>
//                       </select>
//                     </td>
//                     <td>
//                       <input
//                         type="text"
//                         value={product.fabric}
//                         onChange={(e) => {
//                           const updatedProducts = [...products];
//                           updatedProducts[index].fabric = e.target.value;
//                           setProducts(updatedProducts);
//                         }}
//                         contenteditable
//                         formcontrolname="material"
//                       />
//                     </td>
//                     <td>
//                       <input
//                         type="number"
//                         value={product.quantity}
//                         onChange={(e) => {
//                           const updatedProducts = [...products];
//                           updatedProducts[index].quantity = parseInt(e.target.value) || 0;
//                           setProducts(updatedProducts);
//                         }}
//                         contenteditable
//                         formcontrolname="qty"
//                       />
//                     </td>
//                     <td>
//                       <input
//                         type="number"
//                         value={product.price}
//                         onChange={(e) => {
//                           const updatedProducts = [...products];
//                           updatedProducts[index].price = parseFloat(e.target.value) || 0;
//                           setProducts(updatedProducts);
//                         }}
//                         contenteditable
//                         formcontrolname="price"
//                       />
//                     </td>
//                     <td>
//                       <input
//                         type="text"
//                         value={product.quantity * product.price}
//                         readOnly
//                         formcontrolname="total"
//                       />
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="invoice_balance">

//             <table class="balance">
//               <tr>
//                 <th><span>Total Amount ($)</span></th>
//                 <td><input type="number" value={totalPrice} contenteditable="" formcontrolname="totalAmount" class="ng-untouched ng-pristine ng-valid" /></td>
//               </tr>
//               <tr>
//                 <th><span>Amount Paid ($)</span></th>
//                 <td>
//                   <input
//                     type="number"
//                     value={amountPaid}  // Set the value to the state variable
//                     onChange={(e) => setAmountPaid(e.target.value)}  // Update state on change
//                     className="form-control"
//                   />
//                 </td>
//               </tr>
//               <tr>
//                 <th className="no-pdf" colSpan="2">
//                   <div style={{ display: "flex", flexDirection: "column", gap: "15px", marginTop: "10px" }}>
//                     <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Deposit Details <span style={{ fontWeight: "normal" }}>(enter % or amount):</span></label>

//                     {deposits.map((deposit, index) => (
//                       <div
//                         key={index}
//                         style={{
//                           display: "grid",
//                           gridTemplateColumns: "60px 20px 120px 140px",
//                           gap: "10px",
//                           alignItems: "center"
//                         }}
//                       >
//                         <input
//                           type="number"
//                           placeholder="%"
//                           min="0"
//                           max="100"
//                           value={deposit.percent || ""}
//                           onChange={(e) => handleDepositChange(index, "percent", e.target.value)}
//                           style={{ width: "100%", padding: "4px" }}
//                         />
//                         <span style={{ textAlign: "center" }}>%</span>

//                         <input
//                           type="number"
//                           placeholder="Amount $"
//                           min="0"
//                           value={deposit.amount || ""}
//                           onChange={(e) => handleDepositChange(index, "amount", e.target.value)}
//                           style={{ width: "100%", padding: "4px" }}
//                         />

//                         <select
//                           value={deposit.mode || ""}
//                           onChange={(e) => handleDepositChange(index, "mode", e.target.value)}
//                           style={{ width: "100%", padding: "4px" }}
//                         >
//                           <option value="">Mode</option>
//                           <option value="EFT">EFT</option>
//                           <option value="CC">CC</option>
//                           <option value="Cash">Cash</option>
//                         </select>
//                       </div>
//                     ))}
//                   </div>
//                 </th>
//               </tr>


//             </table>
//           </div>


//           <div className="invoice_comment">
//             <div className="form-group">
//               <label htmlFor="comments">Comments</label>
//               <textarea
//                 id="comments"
//                 value={comments}
//                 onChange={(e) => setComments(e.target.value)}  // Add this to update the state
//                 className="form-control"
//               />
//             </div>
//           </div>
//           <div className="invoice_thanks_message">
//             <h5>Thank you for your business</h5>
//           </div>

//           <div className="no-pdf" style={{ marginBottom: "20px" }}>
//             <label><b>Upload Images:</b></label><br />
//             <input
//               type="file"
//               accept="image/*"
//               multiple
//               onChange={(e) => {
//                 const newFiles = Array.from(e.target.files);
//                 // Use the functional update form to append to the existing array
//                 setUploadedImages((prevImages) => [...prevImages, ...newFiles]);
//               }}
//             />
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
//               {uploadedImages.map((img, i) => {
//                 const isFile = img instanceof File;
//                 // Create a URL for previewing the file
//                 const imageUrl = isFile ? URL.createObjectURL(img) : `${config.BASE_URL}${img}`;

//                 return (
//                   <div key={i} style={{ position: 'relative' }}>
//                     <img
//                       src={imageUrl}
//                       alt={`preview-${i}`}
//                       style={{ width: "80px", height: "80px", objectFit: 'cover', border: "1px solid #ccc" }}
//                     />
//                     <button
//                       type="button"
//                       onClick={() => handleRemoveImage(i)}
//                       style={{
//                         position: 'absolute',
//                         top: '2px',
//                         right: '2px',
//                         background: 'rgba(0, 0, 0, 0.5)',
//                         color: 'white',
//                         border: 'none',
//                         borderRadius: '50%',
//                         width: '20px',
//                         height: '20px',
//                         cursor: 'pointer',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         fontSize: '14px',
//                         lineHeight: '1'
//                       }}
//                     >
//                       &times;
//                     </button>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>

//           <div className="invoice_bottom_text">
//             <p><b>Bank Details:</b></p>
//             <p>Bank: Commonwealth Bank Of Australia</p>
//             <p>Account Name: Bentex Suits</p>
//             <p>BSB: 062 443, Account Number: 1084 1834</p>
//             <p>Please Mention Your Invoice Number When Making EFT Payment</p>
//           </div>
//         </div>
//       </div>
//     </Layout>

//   );
// };

// export default Invoice;

import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "./Layout";
import HomeIcon from "../assets/icons/home_icon";
import Logo from "../images/bentex-logo.png";
import axios from "axios";
import config from "../config";
import ClipLoader from "react-spinners/ClipLoader";
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";

const Invoice = ({ customerDetails, invoiceDetails, items, handlePDF }) => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  //   const { search } = useLocation();
  // const query = new URLSearchParams(search);

  // const discount = query.get("discount");
  const [discount,setDiscount] = useState(null)
 

  // invoice states
  const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split("T")[0]);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [status, setStatus] = useState("Pending");
  const [isAutoCreating, setIsAutoCreating] = useState(false);
  // amounts
  const [totalPrice, setTotalPrice] = useState(0);
  const [amountPaid, setAmountPaid] = useState(0);
  const [amountDue, setAmountDue] = useState(0);

  // other fields
  const [deliveryDate, setDeliveryDate] = useState("");
  const [weddingDate, setWeddingDate] = useState("");
  const [comments, setComments] = useState("");
  const [modeOfPayment, setModeOfPayment] = useState("");
  const [customer, setCustomer] = useState(null);
  const [products, setProducts] = useState([]);

  // deposits
  const [deposits, setDeposits] = useState([
    { percent: 0, amount: 0, mode: "" },
    { percent: 0, amount: 0, mode: "" },
    { percent: 0, amount: 0, mode: "" },
  ]);

  // images: existing images (paths on server) and newly uploaded files
  const [existingImages, setExistingImages] = useState([]); // array of strings (server paths)
  const [uploadedImages, setUploadedImages] = useState([]); // array of File objects

  const [isEmailLoading, setIsEmailLoading] = useState(false);

  useEffect(() => {
    // recalc amountDue whenever totalPrice or amountPaid changes
    const t = parseFloat(totalPrice) || 0;
    const paid = parseFloat(amountPaid) || 0;
    setAmountDue(Math.max(0, t - paid));
  }, [totalPrice, amountPaid]);

  const fetchQuoteDetails = async () => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/v1/quoteDetail/${id}`);
      const data = response.data?.quoteDtail ?? response.data?.quoteDetail ?? {};
      const productData = response.data?.productDetail ?? [];

      // Set states
      setInvoiceNo(data?.quoteNo || data?.invoice_no || "");
      setDiscount(data?.discount || 0);
      setTotalPrice(data?.totalPrice ?? data?.amount ?? 0);
      setAmountPaid(data?.amount_paid ?? 0);
      setAmountDue(data?.amount_due ?? (data?.totalPrice ?? 0) - (data?.amount_paid ?? 0));
      setDeliveryDate(data?.deliveryDate ?? "");
      setWeddingDate(data?.weddingDate ?? "");
      setComments(data?.comments ?? "");
      setProducts(productData || []);
      setCustomer(data?.customer_id ?? data?.customer ?? null);

      return { data, productData }; // Return for the auto-save logic
    } catch (err) {
      console.error("Error fetching quote details:", err);
      return null;
    }
  };

  const autoCreateInvoice = async (quoteData, productsList) => {
    if (isAutoCreating) return;
    setIsAutoCreating(true);

    try {
      const formData = new FormData();
      // We use quoteData and productsList directly because state updates might be async
      formData.append("invoiceDate", new Date().toISOString().split("T")[0]);
      formData.append("invoiceNo", quoteData?.quoteNo || generateRandomOrderNo());
      formData.append("totalAmount", String(quoteData?.totalPrice || 0));
      formData.append("amountPaid", "0");
      formData.append("amountDue", String(quoteData?.totalPrice || 0));
      formData.append("customerId", quoteData?.customer_id?._id || quoteData?.customer_id || "");
      formData.append("products", JSON.stringify(productsList || []));
      formData.append("id", id); // Quote ID

      const response = await axios.post(`${config.BASE_URL}/api/v1/addInvoice`, formData);

      if (response.status === 201 || response.status === 200) {
        const createdInvoiceId = response?.data?.invoice?._id;
        // toast.success("Invoice Created successfully");
        navigate(`/edit-invoice/${createdInvoiceId}`, { replace: true });
      }
    } catch (error) {
      console.error("Auto-creation failed:", error);
    } finally {
      setIsAutoCreating(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      // Step A: Check if invoice already exists
      try {
        const checkRes = await axios.get(`${config.BASE_URL}/api/v1/invoice/by-quote/${id}`);
        if (checkRes.status === 200 && checkRes.data?._id) {
          // If exists, just redirect to edit
          navigate(`/edit-invoice/${checkRes.data._id}`, { replace: true });
          return;
        }
      } catch (error) {
        // If 404 (not found), proceed to create
        console.log("No invoice found, creating one...");
      }

      // Step B: Fetch Quote data first
      const quoteInfo = await fetchQuoteDetails();
      
      // Step C: If we have quote data, create the invoice automatically
      if (quoteInfo) {
        await autoCreateInvoice(quoteInfo.data, quoteInfo.productData);
      }
    };

    if (id) {
      init();
    }
  }, [id]);

  useEffect(() => {
     const fetchInvoiceByQuote = async () => {

      try {
         const response = await axios.get(`${config.BASE_URL}/api/v1/invoice/by-quote/${id}`);  
        if (response.status == 200) {
          navigate(`/edit-invoice/${response.data._id}`)
        }
      
    } catch (error) {
      console.log(error,"error")
    }
       
  } 
    
      fetchInvoiceByQuote();
}, [id]);


  // generate random invoice number (keeps original implementation)
  const generateRandomOrderNo = () => {
    const randomNumber = Math.floor(Math.random() * 100000) + 1000;
    return `AR${randomNumber}`;
  };

  const checkOrderNoExistence = async (generatedOrderNo) => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/v1/checkOrderNo`, {
        params: { orderNo: generatedOrderNo },
      });
      return response.data.exists;
    } catch (error) {
      console.error("Error checking quote number existence:", error);
      return false;
    }
  };

  const generateUniqueOrderNo = async () => {
    let isUnique = false;
    let newOrderNo = "";
    while (!isUnique) {
      newOrderNo = generateRandomOrderNo();
      // if API fails, fallback to whatever generated
      const exists = await checkOrderNoExistence(newOrderNo);
      isUnique = !exists;
      if (!exists) break;
    }
    setInvoiceNo(newOrderNo);
  };

  useEffect(() => {
    generateUniqueOrderNo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // deposit handler
  // const handleDepositChange = (index, field, value) => {
  //   const updated = [...deposits];
  //   let numericValue = parseFloat(value) || 0;
  //   if (field === "percent") {
  //     const amount = ((parseFloat(totalPrice) || 0) * numericValue) / 100;
  //     updated[index] = { ...updated[index], percent: numericValue, amount };
  //   } else if (field === "amount") {
  //     const percent = (numericValue / (parseFloat(totalPrice) || 1)) * 100;
  //     updated[index] = { ...updated[index], amount: numericValue, percent };
  //   } else if (field === "mode") {
  //     updated[index] = { ...updated[index], mode: value };
  //   }
  //   setDeposits(updated);

  //   const totalPaid = updated.reduce((acc, d) => acc + (parseFloat(d.amount) || 0), 0);
  //   setAmountPaid(totalPaid);
  // };

  // deposit handler
const handleDepositChange = (index, field, value) => {
    // 1. Get the total invoice amount
    const totalInvoiceAmount = parseFloat(totalPrice) || 0;
    const updated = [...deposits];
    let numericValue = parseFloat(value) || 0;

    // --- Handle Amount Change (CRITICAL VALIDATION) ---
    if (field === "amount") {
        
        // a. Calculate the sum of all *other* deposits
        const otherDepositsTotal = updated.reduce((acc, d, i) => {
            // Sum all amounts EXCEPT the one currently being edited (index)
            if (i !== index) {
                return acc + (parseFloat(d.amount) || 0);
            }
            return acc;
        }, 0);

        // b. Determine the maximum amount allowed for this specific deposit
        const maxAllowed = Math.max(0, totalInvoiceAmount - otherDepositsTotal);
        
        // c. Clamp the input value if it exceeds the max allowed
        if (numericValue > maxAllowed) {
            numericValue = maxAllowed;
            // Provide feedback to the user
            if (maxAllowed >= 0) {
                 toast.warn(`Amount Paid cannot exceed Total Amount ($${totalInvoiceAmount.toFixed(2)}). Capped to remaining amount: $${maxAllowed.toFixed(2)}.`);
            } else {
                 toast.error("Total Paid already exceeds Total Amount!");
            }
        }
        
        // d. Update the amount and recalculate the percentage based on the final numericValue
        updated[index].amount = numericValue;
        const percent = totalInvoiceAmount > 0 ? (numericValue / totalInvoiceAmount) * 100 : 0;
        updated[index].percent = percent.toFixed(2);

    // --- Handle Percent Change (Normal Flow) ---
    } else if (field === "percent") {
        if (numericValue < 0) numericValue = 0;
        if (numericValue > 100) numericValue = 100;

        const calculatedAmount = (numericValue / 100) * totalInvoiceAmount;
        
        // Recalculate based on total
        updated[index].amount = calculatedAmount;
        updated[index].percent = numericValue;

    // --- Handle Mode Change (Simple update) ---
    } else if (field === "mode") {
        updated[index].mode = value;
    }

    // --- Final State Update ---
    setDeposits(updated);
    
    // Recalculate total paid from the final 'updated' array
    const totalPaid = updated.reduce((acc, d) => acc + (parseFloat(d.amount) || 0), 0);
    setAmountPaid(totalPaid);
    
    // Note: amountDue will update via its own useEffect based on totalPrice and amountPaid
};

  // product handlers
 const handleAddItem = () => {
  const newItem = { 
    quote_id: id, 
    description: "", 
    fabric: "", 
    lining: "", 
    quantity: 0, 
    price: 0,
  };
  setProducts((p) => [...p, newItem]);
};

  const handleDeleteItem = (indexToRemove) => {
    setProducts((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  // Image handlers
  const handleUploadedFilesChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setUploadedImages((prev) => [...prev, ...newFiles]);
  };

  const handleRemoveExistingImage = (index) => {
    setExistingImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRemoveUploadedImage = (index) => {
    setUploadedImages((prev) => prev.filter((_, i) => i !== index));
  };

  // generate PDF
  const handleGeneratePDF = () => {
    const element = document.getElementById("invoice");
    const customerName = customer?.customer_name ? customer.customer_name.replace(/\s+/g, "_") : "Customer";
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(today.getMonth() + 1).padStart(2, "0")}-${today.getFullYear()}`;
    const fileName = `Invoice_${customerName}_${formattedDate}.pdf`;
    const options = {
      margin: 0.2,
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        ignoreElements: (el) => el.classList.contains("no-pdf"),
      },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      pagebreak: { 
        mode: ['css', 'legacy'],
        avoid: '.invoice_bottom_text'  
      }
    };
    html2pdf(element, options);
  };

  // email send (original logic kept)
  const handleEmail = async () => {
    if (!customer) {
      toast.error("No customer selected");
      return;
    }
    setIsEmailLoading(true);
    const customerName = customer?.customer_name ? customer.customer_name.replace(/\s+/g, "_") : "Customer";
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(today.getMonth() + 1).padStart(2, "0")}-${today.getFullYear()}`;
    const fileName = `Invoice_${customerName}_${formattedDate}.pdf`;

    try {
      const element = document.getElementById("invoice");
      const options = {
        margin: 0.2,
        filename: fileName,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, ignoreElements: (el) => el.classList.contains("no-pdf") },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
         pagebreak: { 
        mode: ['css', 'legacy'], // Enable CSS parsing
        avoid: '.invoice_bottom_text'  // EXACTLY matches your class name
      }
      };
      const pdfBlob = await html2pdf().from(element).set(options).outputPdf("blob");

      const formData = new FormData();
      formData.append("name", customer.customer_name);
      formData.append("email", customer.email);
      formData.append("subject", invoiceNo);
      formData.append("title", fileName);
      formData.append("pdf", pdfBlob, "invoice.pdf");
      formData.append("type", "invoice");

      // attach uploaded images (if any)
      uploadedImages.forEach((file) => {
        formData.append("invoiceImages", file);
      });

      const response = await axios.post(`${config.BASE_URL}/api/v1/sendEmail`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        toast.success("Email sent successfully!");
      } else {
        toast.error("Failed to send email. Please try again.");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error("Error sending email. Please check the console for more details.");
    } finally {
      setIsEmailLoading(false);
    }
  };

  useEffect(() => {
  const total = products.reduce((acc, p) => {
    const qty = parseFloat(p.quantity) ;
    const price = parseFloat(p.price) ;
    return acc + qty * price;
  }, 0);
  
  if (total !== parseFloat(totalPrice)) {
    const amount = total - discount
    setTotalPrice(amount);
  }
}, [products]);

  // Save / Create invoice
  const [saveLoading,setSaveLoading]=useState(false)
  const handleSave = async () => {
    setSaveLoading(true)
    try {
      const formData = new FormData();
      if (id) formData.append("invoiceId", id);

      // main fields (use names expected by controller)
      formData.append("invoiceDate", invoiceDate || "");
      formData.append("invoiceNo", invoiceNo || "");
      formData.append("amount", String(totalPrice || 0));
      formData.append("totalAmount", String(totalPrice || 0));
      formData.append("amountPaid", String(amountPaid || 0));
      formData.append("amountDue", String(amountDue || 0));
      formData.append("weddingDate", weddingDate || "");
      formData.append("deliveryDate", deliveryDate || "");
      formData.append("status", status || "");
      formData.append("price", String(totalPrice || 0));
      formData.append("comments", comments || "");
      formData.append("modeOfPayment", modeOfPayment || "");
      formData.append("customerId", customer?._id || "");
      formData.append("discount", discount || "");
      formData.append("id", id || ""); // quote id if applicable

      // JSON fields
      formData.append("deposit", JSON.stringify(deposits || []));
      formData.append("products", JSON.stringify(products || []));

      // existing images kept (array of server paths)
      formData.append("existingImages", JSON.stringify(existingImages || []));

      // new image files - key 'images' so multer upload.array('images') will pick them
      uploadedImages.forEach((file) => {
        formData.append("images", file);
      });

      const response = await axios.post(`${config.BASE_URL}/api/v1/addInvoice`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      

      if (response.status === 201 || response.status === 200) {
         setSaveLoading(false)
        const data = await axios.patch(`${config.BASE_URL}/api/v1/quote/update-discount/${id}`, {totalPrice,discount})
        const createdInvoiceId = response?.data?.invoice?._id;
        toast.success("Invoice saved successfully!");
        if (createdInvoiceId) navigate(`/edit-invoice/${createdInvoiceId}`);
      } else {
        setSaveLoading(false)
        toast.error("Failed to save the invoice.");
      }
    } catch (error) {
      setSaveLoading(false)
      console.error("Error saving invoice:", error);
      toast.error("An error occurred while saving the invoice.");
    }
  };

  // Helpers to render image previews
  const renderExistingImagePreviews = () =>
    existingImages.map((imgPath, idx) => {
      const url = imgPath.startsWith("http") ? imgPath : `${config.BASE_URL}${imgPath}`;
      return (
        <div key={`existing-${idx}`} style={{ position: "relative" }}>
          <img
            src={url}
            alt={`existing-${idx}`}
            style={{ width: "80px", height: "80px", objectFit: "cover", border: "1px solid #ccc" }}
          />
          <button
            type="button"
            onClick={() => handleRemoveExistingImage(idx)}
            style={{
              position: "absolute",
              top: "2px",
              right: "2px",
              background: "rgba(0,0,0,0.5)",
              color: "white",
              border: "none",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              lineHeight: "1",
            }}
          >
            &times;
          </button>
        </div>
      );
    });

  const renderUploadedImagePreviews = () =>
    uploadedImages.map((file, idx) => {
      const url = file instanceof File ? URL.createObjectURL(file) : `${config.BASE_URL}${file}`;
      return (
        <div key={`upload-${idx}`} style={{ position: "relative" }}>
          <img
            src={url}
            alt={`upload-${idx}`}
            style={{ width: "80px", height: "80px", objectFit: "cover", border: "1px solid #ccc" }}
          />
          <button
            type="button"
            onClick={() => handleRemoveUploadedImage(idx)}
            style={{
              position: "absolute",
              top: "2px",
              right: "2px",
              background: "rgba(0,0,0,0.5)",
              color: "white",
              border: "none",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              lineHeight: "1",
            }}
          >
            &times;
          </button>
        </div>
      );
    });

  return (
    <Layout>
      <header className="header">
        <h1>Edit Invoice</h1>
        <p>
          <Link to="/" className="home-link">
            <HomeIcon />
          </Link>{" "}
          / Customers / Edit Invoice
        </p>
      </header>

      <div className="invoice_outer">
        <div className="invoce_outer_btns">
          <button onClick={() => handleEmail(customer)} type="button" className="btn" disabled={isEmailLoading}>
            {isEmailLoading ? (
              <>
                <ClipLoader color="#fff" size={18} /> Sending...
              </>
            ) : (
              "Email"
            )}
          </button>

          <button onClick={handleGeneratePDF} className="btn">
            PDF
          </button>
          <button onClick={handleSave} disabled={saveLoading} className="btn">
            Save
          </button>
        </div>

        <div className="invoice_card" id="invoice">
          <div className="invoice_card_header">
            <div className="logo">
              <img src={Logo} alt="logo" />
            </div>
            <p>CBD Showroom: Suite 513, Level 5, 250 Pitt Street, Sydney 2000</p>
            <p>Western Sydney: 6, Ambleside Drive, Castle Hill, NSW 2154</p>
            <p>Ph: 02 9863 6911, Mobile: 0414 984 976</p>
            <p>ABN: 14146359560</p>
          </div>

          <h4 className="tax_invoice_title">Tax Invoice</h4>

          <div className="invoice_custom_details">
            <div className="customer_details">
              <p className="customer_name">{customer?.customer_name}</p>
              <p className="location">{customer?.address}</p>
              <p className="email">{customer?.email}</p>
              <p className="phone_number">{customer?.mobile}</p>
            </div>

            <div className="invoice_details_table">
              <table className="meta">
                <tbody>
                  <tr>
                    <th>
                      <span>Invoice #</span>
                    </th>
                    <td>
                      <span>{invoiceNo}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>Date</span>
                    </th>
                    <td>
                      <input type="date" value={invoiceDate} onChange={(e) => setInvoiceDate(e.target.value)} />
                    </td>
                  </tr>
               
                    { discount > 0 && <tr>
                    <th>
                      <span>Discount</span>
                    </th>
                    <td>
                      {discount}
                    </td>
                  </tr>}
                       <tr>
                    <th>
                      <span>Amount Due ($)</span>
                    </th>
                    <td>
                      <input type="number" value={amountDue} readOnly />
                    </td>
                  </tr>
                   
                </tbody>
              </table>
            </div>
          </div>

          <div className="invoice_specification_details">
            <table className="details">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Fabric / Lining</th>
                  <th>Quantity</th>
                  <th>Price ($)</th>
                  <th>Amount ($)</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product, index) => (
                  <tr key={index}>
                    <td className="with_cut_td">
                      {/* {index === products.length - 1 ? (
                        <a className="cut" onClick={handleAddItem}>
                          +
                        </a>
                      ) : (
                        <a className="cut" onClick={() => handleDeleteItem(index)}>
                          x
                        </a>
                      )}

                      <select
                        id="description"
                        value={product.description || ""}
                        onChange={(e) => {
                          const updatedProducts = [...products];
                          updatedProducts[index].description = e.target.value;
                          setProducts(updatedProducts);
                        }}
                      >
                        <option value=""> </option>
                        <option value="Suit">Suit</option>
                        <option value="Jacket">Jacket</option>
                        <option value="Shirt">Shirt</option>
                        <option value="Pant">Pant</option>
                        <option value="Tuxedo">Tuxedo</option>
                        <option value="Vest">Vest</option>
                        <option value="Overcoat">Overcoat</option>
                        <option value="Accessories">Accessories</option>
                      </select> */}
                        <input type="text" value={product.description} disabled />
                    </td>

                    <td>
                      <input
                        type="text"
                        value={product.fabric || ""}
                        onChange={(e) => {
                          const updatedProducts = [...products];
                          updatedProducts[index].fabric = e.target.value;
                          setProducts(updatedProducts);
                        }}
                      />
                    </td>

                    <td>
                      <input
                        type="number"
                        value={product.quantity || 0}
                        // onChange={(e) => {
                        //   const updatedProducts = [...products];
                        //   updatedProducts[index].quantity = parseInt(e.target.value) || 0;
                        //   setProducts(updatedProducts);
                        // }}
                      />
                    </td>

                    <td>
                      <input
                        type="number"
                        value={product.price || 0}
                        onChange={(e) => {
                          const updatedProducts = [...products];
                          updatedProducts[index].price = parseFloat(e.target.value) ;
                          setProducts(updatedProducts);
                        }}
                      />
                    </td>

                    <td>
                      <input type="text" value={(product.quantity || 0) * (product.price || 0)} readOnly />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="invoice_balance">
            <table className="balance">
              <tbody>
                <tr>
                  <th>
                    <span>Total Amount ($)</span>
                  </th>
                  <td>
                    <input
                      type="number"
                      value={totalPrice || 0}
                      // onChange={(e) => setTotalPrice(parseFloat(e.target.value) || 0)}
                    />
                  </td>
                </tr>

                <tr>
                  <th>
                    <span>Amount Paid ($)</span>
                  </th>
                  <td>
                    <input
                      type="number"
                       min="0"
                      value={amountPaid}
                      // onChange={(e) => setAmountPaid(parseFloat(e.target.value) )}
                      className="form-control"
                    />
                  </td>
                </tr>

                <tr>
                  <th className="no-pdf" colSpan="2">
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px", marginTop: "10px" }}>
                      <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
                        Deposit Details <span style={{ fontWeight: "normal" }}>(enter % or amount):</span>
                      </label>

                      {deposits.map((deposit, index) => (
                        <div
                          key={index}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "60px 20px 120px 140px",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="number"
                            placeholder="%"
                            min="0"
                            max="100"
                            value={deposit.percent || ""}
                            onChange={(e) => handleDepositChange(index, "percent", e.target.value)}
                            style={{ width: "100%", padding: "4px" }}
                          />
                          <span style={{ textAlign: "center" }}>%</span>

                          <input
                            type="number"
                            placeholder="Amount $"
                            min="0"
                            value={deposit.amount || ""}
                            onChange={(e) => handleDepositChange(index, "amount", e.target.value)}
                            style={{ width: "100%", padding: "4px" }}
                          />

                          <select
                            value={deposit.mode || ""}
                            onChange={(e) => handleDepositChange(index, "mode", e.target.value)}
                            style={{ width: "100%", padding: "4px" }}
                          >
                            <option value="">Mode</option>
                            <option value="EFT">EFT</option>
                            <option value="CC">CC</option>
                            <option value="Cash">Cash</option>
                          </select>
                        </div>
                      ))}
                    </div>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="invoice_comment">
            <div className="form-group">
              <label htmlFor="comments">Comments</label>
              <textarea id="comments" value={comments} onChange={(e) => setComments(e.target.value)} className="form-control" />
            </div>
          </div>

          <div className="invoice_thanks_message">
            <h5>Thank you for your business</h5>
          </div>

          <div className="no-pdf" style={{ marginBottom: "20px" }}>
            <label>
              <b>Upload Images:</b>
            </label>
            <br />
            <input type="file" accept="image/*" multiple onChange={handleUploadedFilesChange} />
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
              {renderExistingImagePreviews()}
              {renderUploadedImagePreviews()}
            </div>
          </div>

          <div className="invoice_bottom_text">
            <p>
              <b>Bank Details:</b>
            </p>
            <p>Bank: Commonwealth Bank Of Australia</p>
            <p>Account Name: Bentex Suits</p>
            <p>BSB: 062 443, Account Number: 1084 1834</p>
            <p>Please Mention Your Invoice Number When Making EFT Payment</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Invoice;

